// Everything on the home page below the first screen. Loaded as its own file and built
// just after the first paint, so the hero and cookie banner appear without waiting for it.
import StatsSection from '@/components/sections/StatsSection';
import ServicesOverview from '@/components/sections/ServicesOverview';
import BundleSection from '@/components/sections/BundleSection';
import EstateAgentsSection from '@/components/sections/EstateAgentsSection';
import WhyChooseUs from '@/components/sections/WhyChooseUs';
import CoverageSection from '@/components/sections/CoverageSection';
import FinalCTA from '@/components/sections/FinalCTA';
import TestimonialsSection from '@/components/sections/TestimonialsSection';

export default function HomeBelowFold() {
  return (
    <>
      <StatsSection />
      <ServicesOverview />
      <BundleSection />
      <EstateAgentsSection showLettingAgentLink />
      <WhyChooseUs />
      <CoverageSection showLondonLink />
      <TestimonialsSection />
      <FinalCTA />
    </>
  );
}
